<template>
  <modal 
    name="winner-evalution-modal"
    @closed="$emit('updateComparisonData')"
    @before-open="handleBeforeOpen"
    style="z-index: 1001;"
  >
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Մասնակիցներրի գնահատում</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('winner-evalution-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row">
        <div class="col-md-12">
          <table class="table table-bordered m-0" style="border-collapse: collapse; border-spacing: 0; width: 100% !important;;">
            <thead>
              <tr>
                <th style="width: 120px;">Հ/Հ</th>
                <th>Անվանում</th>
                <th>Գնման առարկա</th>
                <th>Ներկայացված գին</th>
                <th>Ներկայացված տեխնիկական բնութագիր</th>
                <th>
                  <template v-if="organizeType !== 3">
                    Գնահատում
                  </template>
                  <template v-else>
                    Հաղթող
                  </template>
                </th>
              </tr>
            </thead>
            <tbody v-if="participants.length" id="comparison-table" style="min-height: 5vh; max-height: 40vh!important; overflow: scroll">
              <template v-for="(participant, participantIndex) in participants">
                <tr :key="participant.id">
                  <td :rowspan="participant.lots.length + 1">{{ participantIndex + 1 }}</td>
                  <td :rowspan="participant.lots.length + 1">{{ participant.name }}</td>
                </tr>
                <template>
                  <tr
                    :key="`${participantIndex} + ${lot.id}`"
                    v-for="(lot, lotIndex) in participant.lots"
                    :style="lotIndex === participant.lots.length - 1 && participantIndex !== participants.length -1 ? 'border-bottom: 3px solid rgb(193 193 193);' : ''"
                  >
                    <td :style="lotIndex === 0 ? 'border: none' : ''">{{lot.cpv.name}}</td>
                    <td :style="lotIndex === 0 ? 'border: none' : ''">{{lot.cost}}</td>
                    <td :style="lotIndex === 0 ? 'border: none' : ''">{{lot.specification}}</td>
                    <template v-if="winnerByLots">
                      <td :style="lotIndex === 0 ? 'border: none' : ''">
                        <template v-if="organizeType !== 3">
                          <div class="form-check">
                            <input 
                              v-model="lot.is_satisfactory"
                              :value="1"
                              class="form-check-input"
                              type="radio"
                              :name="`is_satisfactory-${lot.id}-${participant.id}`"
                              :id="`is_satisfactory-${lot.id}-${participant.id}`"
                            >
                            <label class="form-check-label" :for="`is_satisfactory-${lot.id}-${participant.id}`">
                              Բավարար
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              v-model="lot.is_satisfactory"
                              :value="0"
                              class="form-check-input"
                              type="radio"
                              :name="`is_satisfactory-false-${lot.id}-${participant.id}`"
                              :id="`is_satisfactory-false-${lot.id}-${participant.id}`"
                            >
                            <label class="form-check-label" :for="`is_satisfactory-false-${lot.id}-${participant.id}`">
                              Անբավարար
                            </label>
                          </div>
                          <div v-if="!lot.is_satisfactory" class="form-group text-left my-2">
                            <label :for="`reason-${lot.id}-${participant.id}`">Հիմնավորում</label>
                            <textarea v-model="lot.rejection_reason" class="form-control" :id="`reason-${lot.id}-${participant.id}`" rows="3"></textarea>
                          </div>
                        </template>
                        <template v-else>
                          <input
                            v-model="winnerRows[lot.organize_row_id]"
                            :name="`winner-${lot.organize_row_id}`"
                            :id="`winner-${lot.organize_row_id}`"
                            :value="participant.id"
                            type="radio" 
                          >
                        </template>
                      </td>
                    </template>
                    <template v-else>
                      <td v-if="lotIndex === 0" :rowspan="participant.lots.length + 1">
                        <template v-if="organizeType !== 3">
                          <div class="form-check">
                            <input 
                              v-model="lot.is_satisfactory"
                              :value="1"
                              class="form-check-input"
                              type="radio"
                              :name="`is_satisfactory-${lot.id}-${participant.id}`"
                              :id="`is_satisfactory-${lot.id}-${participant.id}`"
                            >
                            <label class="form-check-label" :for="`is_satisfactory-${lot.id}-${participant.id}`">
                              Բավարար
                            </label>
                          </div>
                          <div class="form-check">
                            <input
                              v-model="lot.is_satisfactory"
                              :value="0"
                              class="form-check-input"
                              type="radio"
                              :name="`is_satisfactory-false-${lot.id}-${participant.id}`"
                              :id="`is_satisfactory-false-${lot.id}-${participant.id}`"
                            >
                            <label class="form-check-label" :for="`is_satisfactory-false-${lot.id}-${participant.id}`">
                              Անբավարար
                            </label>
                          </div>
                          <div v-if="!lot.is_satisfactory" class="form-group text-left my-2">
                            <label :for="`reason-${lot.id}-${participant.id}`">Հիմնավորում</label>
                            <textarea v-model="lot.rejection_reason" class="form-control" :id="`reason-${lot.id}-${participant.id}`" rows="3"></textarea>
                          </div>
                        </template>
                        <template v-else>
                          <input v-model="winnerId" type="radio" id="winner" name="winner" :value="participant.id">
                        </template>
                      </td>
                    </template>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button :disabled="isLoading" @click="save" class="btn btn-primary">
        <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'WinnerEvalutionModal',
    components: {  },
    data() {
      return {
        isLoading: false,
        participantGroup: {},
        winnerByLots: false,
        is_satisfactory: 1,
        participants: [],
        organizeType: 1,
        winnerId: 0,
        winnerRows: {},
      }
    },
    computed: {
      currentOrganized() {
        return this.$store.getters['organizeItender/currentOrganized']
      },
      organizedRowsList() {
        return this.$store.getters['organizeItender/organizedRows']
      },
    },
    methods: {
      consoleLog(msg) {
        console.log(msg)
      },
      handleBeforeOpen({params}) {
        this.organizeType = this.organizedRowsList[0].type
        this.organizedRowsList.forEach((row) => {
          const rowId = row.id;
          this.winnerRows[rowId] = row.winner.id;
        })
        if(this.currentOrganized.winners.length){
          this.winnerId = this.currentOrganized.winners[0].id;
        }
        this.participants = Object.assign(this.currentOrganized.participants)
        this.participants.forEach((participant) => {
          participant.lots.forEach((lot) => {
            lot.cpv = lot.row.procurement_plan.is_from_outside ? 
                      lot.row.procurement_plan.cpv_outside : lot.row.procurement_plan.cpv
          })
        })
        this.winnerByLots = this.currentOrganized.winner_by_lots
      },
      save() {
        if(this.organizeType === 1){
          console.log('typ1')
          this.$client.post(`organize/itender/evalution/${this.currentOrganized.id}`, this.participants).then(({data: {data}}) => {
            if(data) {
              this.$store.commit('organizeItender/setCurrentOrganized', data)
              this.$modal.hide('winner-evalution-modal')
            }
          })
        } else if(this.organizeType === 3){
          let requestData = {winner: this.winnerId}
          if(this.currentOrganized.winner_by_lots){
            requestData = {winnerRows: this.winnerRows}
          }
          this.$client.post(`organize/itender/setWinner/${this.currentOrganized.id}`, requestData).then(({data: {data}}) => {
            if(data) {
              this.$store.commit('organizeItender/setCurrentOrganized', data)
              this.$modal.hide('winner-evalution-modal')
            }
          })
        }
      }
    },
  }
</script>

<style scoped>
 .date-picker {
    display: block;
    width: 100%;
    border: 1px solid #e8ebf3;
    border-radius: .25rem;
    border-bottom: 1px solid #e8ebf3;
  }
  /deep/ .vdpWithInput > input {
    width: 100%;
    height: calc(1.8em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: .845rem;
    font-weight: 400;
    line-height: 1.8;
    color: #303e67;
    border: none;
  }
  /deep/ .vm--modal {
    top: 0 !important;
    bottom: 0 !important;
    width: 1200px !important;
    position: absolute;
    right: 0 !important;;
    left: 0 !important;;
    margin: auto;
    height: 80% !important;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>